import { Info12Filled, PersonChat24Regular } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import { logEvent } from "./AppInsightsHelper";

const security360TeamsChannelLink = "https://teams.microsoft.com/l/channel/19%3A8b7b5e2a73504173981affdd3afbe811%40thread.tacv2/Security%20360?groupId=220a9a3b-eacf-4cb1-927b-7c8bbd4562ca&tenantId=72f988bf-86f1-41af-91ab-2d7cd011db47";
export default function HeaderHelpBody() {
  const navigate = useNavigate();
  const onNavigateGlossary = (e) => {
    e.preventDefault();
    logEvent("Glossary Link Clicked" , "Help Page" , "MailTo" , "glossary");
    navigate("/glossary");
  };
  return (
    <>
      <br />
      <div style={{ display: "flex", position: "relative" }}>
        <span>
          <Info12Filled style={{ position: "absolute", width: "22px", height: "17px" }} /> &nbsp;
          <a
            href="javascipt:void(0)"
            onClick={onNavigateGlossary}
            style={{
              position: "absolute",
              left: "10%",
              color: "blue",
              fontSize: "13px"
            }}
          >
            Glossary
          </a>
        </span>
      </div>
      <div style={{ display: "flex", position: "relative" }}>
        <span>
          {" "}
          <PersonChat24Regular style={{ position: "absolute", width: "22px", height: "17px" }} />
          &nbsp;&nbsp;
          <a href="javascipt:void(0)" onClick={() => window.open(security360TeamsChannelLink)} style={{ position: "absolute", left: "10%", fontSize: "13px" }}>
            Contact Us
          </a>
        </span>
      </div>
      <div style={{ display: "flex", position: "relative" }}>
        <span>
          <Info12Filled style={{ position: "absolute", width: "22px", height: "17px" }} /> &nbsp;
          <a
            href="https://privacy.microsoft.com/en-US/data-privacy-notice"
            target="_blank"
            style={{
              position: "absolute",
              left: "10%",
              color: "blue",
              fontSize: "13px"
            }}
          >
            Data Privacy Notice
          </a>
        </span>
      </div>
    </>
  );
}
